export const select = {
  sex: {
    title: 'Sex',
    value: {
      male: 'Male',
      female: 'Female'
    }
  },
  select_or_type: 'Select or Enter',
  required_trunk: 'Select data source'
};
